import { Instrument } from '../../../lib/cli/supported-instruments'

export const getStemsByInstrument = (
  list: Instrument[],
  selected: string[]
): string[] => {
  const stemsArray: string[] = []

  selected.forEach((instrumentId) => {
    const groupSelected = list.find(
      (item) =>
        item.id === instrumentId ||
        item.stems.some((item2) => item2.id === instrumentId)
    )

    if (groupSelected) {
      const selectedStem = groupSelected.stems.find(
        (stem) => stem.id === instrumentId
      )

      if (selectedStem) {
        stemsArray.push(...selectedStem.stems)
      }
    }
  })

  return stemsArray
}
